import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "./ui/button";
import { Logo } from "./navbar/Logo";
import { AuthButtons } from "./navbar/AuthButtons";
import { UserMenu } from "./navbar/UserMenu";
import { DesktopNav } from "./navbar/DesktopNav";
import { MobileNav } from "./navbar/MobileNav";

interface NavbarProps {
  className?: string;
  profile?: any;
  session?: any;
}

export function Navbar({ className, profile, session }: NavbarProps) {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isMicrosite, setIsMicrosite] = useState(false);

  useEffect(() => {
    const micrositeExp = sessionStorage.getItem("microsite_exp");
    if (micrositeExp) {
      setIsMicrosite(true);
    }
  });

  return (
    <nav
      className={cn("border-b bg-white shadow-sm sticky top-0 z-50", className)}
    >
      <div className="container mx-auto">
        <div className="flex h-16 items-center justify-between">
          <div>
            <Logo
              session={session?.access_token}
              className="text-primary hover:text-primary-hover transition-colors"
            />
          </div>

          <div className="flex-1">
            {!isMicrosite && !session && (
              <DesktopNav profile={profile} session={session} />
            )}
          </div>

          {!isMicrosite && (
            <div
              className={`flex items-center justify-end ${
                profile ? "w-[280px]" : "w-[180px]"
              }`}
            >
              <div className={`hidden md:block ${profile ? "w-full" : ""}`}>
                {profile ? (
                  <UserMenu profile={profile} session={session} />
                ) : (
                  <AuthButtons />
                )}
              </div>
              <Button
                variant="ghost"
                size="icon"
                className="md:hidden text-primary hover:text-primary-hover hover:bg-accent"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <Menu className="h-6 w-6" />
              </Button>
            </div>
          )}
        </div>
      </div>

      {!isMicrosite && (
        <MobileNav
          profile={profile}
          session={session}
          isOpen={isMenuOpen}
          onClose={() => setIsMenuOpen(false)}
        />
      )}
    </nav>
  );
}
